import {currentUserData} from "./user";

export const AuthTeacher = 1
export const AuthAcademic = 2
export const AuthAdmin = 4
export const AuthSuperAdmin = 8
export const AuthStudent = 16
export const AuthManagerAdmin = 32
export const AuthConsultant = 64

export function checkAuth(user: currentUserData | undefined, auth: number) {
    if (!user){
        return false;
    }
    return (user.auth & auth) !== 0
}


export function checkAuths(user: currentUserData | undefined, auth: number[]) {
    if (!auth){
        return false;
    }
    for (let i = 0; i < auth.length; i++) {
        const a = auth[i];

        if (checkAuth(user, a)){
            return true;
        }
    }
    return false;
}